import React from "react";
import "./Footer.css";

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <img className="footer-img" src="icon-white.png" alt="QKart"></img>
      </footer>
    );
  }
}

